import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const deleteUploadedFile = async (key, directory = 'assetfiles') => {
  const encoded = encodeURIComponent(key);
  try {
    const response = await axiosInstance.delete(
      `${API_URL}/upload/${directory}/${encoded}`,
    );
    return response.data;
  } catch (error) {
    const message = error.response?.data || error.message || 'Unknown error';
    throw new Error(`Delete failed: ${message}`);
  }
};
